import { Component, OnInit } from '@angular/core';
import { Zone } from '../../models/zone.model';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { AddBirthdayZoneModalComponent } from '../../components/modals/add-birthday-zone-modal/add-birthday-zone-modal.component';
import { ModalController } from '@ionic/angular';
import { EditBirthdayZoneModalComponent } from '../../components/modals/edit-birthday-zone-modal/edit-birthday-zone-modal.component';
import { PlayroomService } from '../../services/playroom.service';
import { Playroom } from '../../models/playroom.model';
import { DeleteZoneModalComponent } from '../../components/modals/delete-zone-modal/delete-zone-modal.component';
@Component({
  selector: 'app-manage-birthday-zones',
  templateUrl: './manage-birthday-zones.page.html',
  styleUrls: ['./manage-birthday-zones.page.scss'],
})
export class ManageBirthdayZonesPage implements OnInit {
zona: Zone;
playroom:Playroom
rooms=[];
paginationSettings = {totalItems: 0};
currentPage: number = 1;
 itemsPerPage: number = 10;
zones$ = this.rodjendanskezoneservice.$zona;
plays$=this.playroomservice.playrooms$
  zoneNameQuery: string = '';
  maxChildNumbereQueryMin: string = '';
  maxChildNumbereQueryMax :string = '';
  maxAdultNumberQueryMin :string = ''; 
  maxAdultNumberQueryMax :string = '';
  roomnameQuery: string = '';
  constructor(private rodjendanskezoneservice:RodjendanskezoneService,private modalController: ModalController, private playroomservice:PlayroomService) { }

  ngOnInit() {
 this.playroomservice.getAllPlayrooms()
 console.log('ZONES',this.zones$)
  console.log('plays$',this.plays$)
     this.rodjendanskezoneservice.getAllZone({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax:this.maxChildNumbereQueryMax 
        , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax ,  RoomNameQuery:this.roomnameQuery})
 this.rodjendanskezoneservice.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });

this.plays$.subscribe(data => {
    this.rooms = data;
    console.log('Playrooms učitani:', this.rooms);
  });

}
 changePage(pageNumber) {
    this.currentPage = pageNumber;
    this.rodjendanskezoneservice.getAllZone({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax:this.maxChildNumbereQueryMax 
        , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax ,  RoomNameQuery:this.roomnameQuery})
  }




 async loadSearchResult(){
    
      this.rodjendanskezoneservice.getAllZone({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax:this.maxChildNumbereQueryMax 
        , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax ,  RoomNameQuery:this.roomnameQuery})
  }
  resetFilters() {
    this.rodjendanskezoneservice.getAllZone();
    this.zoneNameQuery = '';
    this.maxChildNumbereQueryMin = '';
    this.maxChildNumbereQueryMax = '';
    this.maxAdultNumberQueryMin = '';
    this.maxAdultNumberQueryMax = '';
    this.roomnameQuery = '';
  }
   async openAddBirthdayZoneModal() {
 const modal = await this.modalController.create({
     component: AddBirthdayZoneModalComponent,
  
     cssClass: 'medium-modal-css',
     backdropDismiss: true,
     swipeToClose: false,
   }); 

   await modal.present();


    console.log("Add Zone")
} 


async openEditBirthdayZoneModal(zone) {

  const room = this.rooms.find(r => r.roomName === zone.roomName);
console.log('ROOM', room);
console.log('ZONE', zone);
  const zoneWithRoomId = {
    ...zone,
    roomId: room ? room.id : null
  };

  console.log('ZONE sa roomId:', zoneWithRoomId);

  const modal = await this.modalController.create({
    component: EditBirthdayZoneModalComponent,
    componentProps: {
      zone: zoneWithRoomId,
      rooms: this.rooms
    },
    cssClass: 'medium-modal-css',
    backdropDismiss: true,
    swipeToClose: false,
  });

  await modal.present();
}



 async openDeleteRampModal(zone) {
console.log(  'ZONE DELETE', zone)

   const modal = await this.modalController.create({
     component: DeleteZoneModalComponent,
      componentProps: {zone}, 
     cssClass: 'small-modal-css',
     backdropDismiss: true,
     swipeToClose: false,
   });
   await modal.present();
 }
}
